// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"600":"04b97e84eea5c720","1952":"1ac993a00a76e7ee"}[chunkId] + ".js";
};